$(document).ready(function () {

  function updateFreeShippingBar($bar) {
    const threshold = parseFloat($bar.data('threshold')) * 100;
    const currency = $bar.data('currency');
    const successMessage = $bar.data('success-message');
    const progressMessage = $bar.data('progress-message');

    const $message = $bar.find('[data-message]');
    const $messageText = $bar.find('[data-message-text]');
    const $progressFill = $bar.find('[data-progress-fill]');

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const total = cart.total_price;
        const remaining = threshold - total;
        const percent = Math.min((total / threshold) * 100, 100);

        $progressFill.css('width', percent + '%');

        if (remaining <= 0) {
          $messageText.text(successMessage);
          $message.addClass('success');
          $progressFill.addClass('complete');
        } else {
          const formatted = formatMoney(remaining, currency);
          console.log("formatted", formatted);
          $messageText.text(
            progressMessage.replace('[amount]', formatted)
          );

          $message.removeClass('success');
          $progressFill.removeClass('complete');
        }
      })
      .catch(() => {
        console.error('Free shipping bar error');
      });
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  setTimeout(() => {
    
  
  // Init
    $('.free-shipping-bar').each(function () {
        updateFreeShippingBar($(this));
    });

    // Cart update hooks
    $(document).on(
        'cart:updated cart:refresh cart:change added_to_cart',
        function () {
        $('.free-shipping-bar').each(function () {
            updateFreeShippingBar($(this));
        });
        }
    );
  }, 2000);

});